import ImageAsset from '../Components/ImageAsset';
import SpritesheetAsset from '../Components/SpritesheetAsset';
import { percentage } from '../helpers/helpers';
import { useAppSelector } from '../redux';
import store, { RootState } from '../store';
import './Game.scss';
import { gameActions } from './gameSlice';

function PlayerAvatar() {

  const gameState = useAppSelector((state: RootState) => state.game)

  const getGameAvatar = () => {
    if (
      percentage(gameState.player.attributes.currentHp, gameState.player.attributes.maxHp) <= 15 ||
      gameState.player.attributes.currentHp <= 3
    ) {
      const splitList = gameState.player.sprite.split('.');

      if (!splitList || splitList.length !== 2) {
        return gameState.player.sprite;
      }

      return `${splitList[0]}-dmg.${splitList[1]}`;
    }

    return gameState.player.sprite;
  }

  {/* click on player avatar does not trigger scoreboard */ }
  return (
    < div className="player-avatar" /* onClick={() => store.dispatch(gameActions.showScoreboard())} */ >
      <SpritesheetAsset name={getGameAvatar()} multiplier={7} />
    </div >
  );
}

export default PlayerAvatar;
